import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor,
  HttpResponse,
  HttpContextToken
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ErrorCodes } from '@/models/error/error.model';
import { ErrorSection, ErrorSectionsService, ErrorSectionType } from '@/presentation/services/error-sections.service';

export const SECTION_KEY = new HttpContextToken<string>(() => 'global');
export const IGNORE_NO_CONTENT_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class ErrorSectionsInterceptor implements HttpInterceptor {
  #errorSectionsService: ErrorSectionsService = inject(ErrorSectionsService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sectionKey = req.context.get(SECTION_KEY);
    const ignoreNoContent = req.context.get(IGNORE_NO_CONTENT_ERROR);

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>): void => {
        if (event instanceof HttpResponse) {
          if (event.status === ErrorCodes.NO_CONTENT && !ignoreNoContent) {
            if (sectionKey) {
              this.#errorSectionsService.setSectionInError(sectionKey, {
                errorType: ErrorSectionType.EMPTY_CONTENT
              });
            }
          } else if (event.ok) {
            this.#errorSectionsService.setSectionInError(sectionKey);
          }
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (sectionKey) {
          this.#errorSectionsService.setSectionInError(sectionKey, this.#mapErrorSectionType(err));
        }
        return throwError(() => err);
      })
    );
  }

  #mapErrorSectionType(error: HttpErrorResponse): ErrorSection {
    switch (error?.status) {
      case ErrorCodes.LOCKED:
        return {
          errorType: ErrorSectionType.LOCKED
        };
      case ErrorCodes.SECTION_MAINTENANCE:
        return {
          errorType: ErrorSectionType.MAINTENANCE
        };
      case ErrorCodes.NO_CONTENT:
        return {
          errorType: ErrorSectionType.EMPTY_CONTENT
        };
      default:
        return {
          errorType: ErrorSectionType.DEFAULT
        };
    }
  }
}
